import { Button, Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransmissionSchedule extends Layout {
    button3xDay: Button;
    buttonAM: Button;
    buttonAmPm: Button;
    buttonEvenHours: Button;
    buttonOddHours: Button;
    buttonPM: Button;
    buttonWorkHours: Button;
    checkboxDayOfWeek: Checkbox;
    checkboxFri0: Checkbox;
    checkboxFri10: Checkbox;
    checkboxFri11: Checkbox;
    checkboxFri12: Checkbox;
    checkboxFri13: Checkbox;
    checkboxFri14: Checkbox;
    checkboxFri15: Checkbox;
    checkboxFri16: Checkbox;
    checkboxFri17: Checkbox;
    checkboxFri18: Checkbox;
    checkboxFri19: Checkbox;
    checkboxFri1: Checkbox;
    checkboxFri20: Checkbox;
    checkboxFri21: Checkbox;
    checkboxFri22: Checkbox;
    checkboxFri23: Checkbox;
    checkboxFri2: Checkbox;
    checkboxFri3: Checkbox;
    checkboxFri4: Checkbox;
    checkboxFri5: Checkbox;
    checkboxFri6: Checkbox;
    checkboxFri7: Checkbox;
    checkboxFri8: Checkbox;
    checkboxFri9: Checkbox;
    checkboxFriday: Checkbox;
    checkboxMon0: Checkbox;
    checkboxMon10: Checkbox;
    checkboxMon11: Checkbox;
    checkboxMon12: Checkbox;
    checkboxMon13: Checkbox;
    checkboxMon14: Checkbox;
    checkboxMon15: Checkbox;
    checkboxMon16: Checkbox;
    checkboxMon17: Checkbox;
    checkboxMon18: Checkbox;
    checkboxMon19: Checkbox;
    checkboxMon1: Checkbox;
    checkboxMon20: Checkbox;
    checkboxMon21: Checkbox;
    checkboxMon22: Checkbox;
    checkboxMon23: Checkbox;
    checkboxMon2: Checkbox;
    checkboxMon3: Checkbox;
    checkboxMon4: Checkbox;
    checkboxMon5: Checkbox;
    checkboxMon6: Checkbox;
    checkboxMon7: Checkbox;
    checkboxMon8: Checkbox;
    checkboxMon9: Checkbox;
    checkboxMonday: Checkbox;
    checkboxSat0: Checkbox;
    checkboxSat10: Checkbox;
    checkboxSat11: Checkbox;
    checkboxSat12: Checkbox;
    checkboxSat13: Checkbox;
    checkboxSat14: Checkbox;
    checkboxSat15: Checkbox;
    checkboxSat16: Checkbox;
    checkboxSat17: Checkbox;
    checkboxSat18: Checkbox;
    checkboxSat19: Checkbox;
    checkboxSat1: Checkbox;
    checkboxSat20: Checkbox;
    checkboxSat21: Checkbox;
    checkboxSat22: Checkbox;
    checkboxSat23: Checkbox;
    checkboxSat2: Checkbox;
    checkboxSat3: Checkbox;
    checkboxSat4: Checkbox;
    checkboxSat5: Checkbox;
    checkboxSat6: Checkbox;
    checkboxSat7: Checkbox;
    checkboxSat8: Checkbox;
    checkboxSat9: Checkbox;
    checkboxSaturday: Checkbox;
    checkboxSun10: Checkbox;
    checkboxSun11: Checkbox;
    checkboxSun12: Checkbox;
    checkboxSun13: Checkbox;
    checkboxSun14: Checkbox;
    checkboxSun15: Checkbox;
    checkboxSun16: Checkbox;
    checkboxSun17: Checkbox;
    checkboxSun18: Checkbox;
    checkboxSun19: Checkbox;
    checkboxSun1: Checkbox;
    checkboxSun20: Checkbox;
    checkboxSun21: Checkbox;
    checkboxSun22: Checkbox;
    checkboxSun23: Checkbox;
    checkboxSun2: Checkbox;
    checkboxSun3: Checkbox;
    checkboxSun4: Checkbox;
    checkboxSun5: Checkbox;
    checkboxSun6: Checkbox;
    checkboxSun7: Checkbox;
    checkboxSun8: Checkbox;
    checkboxSun9: Checkbox;
    checkboxSunO: Checkbox;
    checkboxSunday: Checkbox;
    checkboxThu10: Checkbox;
    checkboxThu11: Checkbox;
    checkboxThu12: Checkbox;
    checkboxThu13: Checkbox;
    checkboxThu14: Checkbox;
    checkboxThu15: Checkbox;
    checkboxThu16: Checkbox;
    checkboxThu17: Checkbox;
    checkboxThu18: Checkbox;
    checkboxThu19: Checkbox;
    checkboxThu1: Checkbox;
    checkboxThu20: Checkbox;
    checkboxThu21: Checkbox;
    checkboxThu22: Checkbox;
    checkboxThu23: Checkbox;
    checkboxThu2: Checkbox;
    checkboxThu3: Checkbox;
    checkboxThu4: Checkbox;
    checkboxThu5: Checkbox;
    checkboxThu6: Checkbox;
    checkboxThu7: Checkbox;
    checkboxThu8: Checkbox;
    checkboxThu9: Checkbox;
    checkboxThurs0: Checkbox;
    checkboxThursday: Checkbox;
    checkboxTue0: Checkbox;
    checkboxTue10: Checkbox;
    checkboxTue11: Checkbox;
    checkboxTue12: Checkbox;
    checkboxTue13: Checkbox;
    checkboxTue14: Checkbox;
    checkboxTue15: Checkbox;
    checkboxTue16: Checkbox;
    checkboxTue17: Checkbox;
    checkboxTue18: Checkbox;
    checkboxTue19: Checkbox;
    checkboxTue1: Checkbox;
    checkboxTue20: Checkbox;
    checkboxTue21: Checkbox;
    checkboxTue22: Checkbox;
    checkboxTue23: Checkbox;
    checkboxTue2: Checkbox;
    checkboxTue3: Checkbox;
    checkboxTue4: Checkbox;
    checkboxTue5: Checkbox;
    checkboxTue6: Checkbox;
    checkboxTue7: Checkbox;
    checkboxTue8: Checkbox;
    checkboxTue9: Checkbox;
    checkboxTuesday: Checkbox;
    checkboxWed10: Checkbox;
    checkboxWed11: Checkbox;
    checkboxWed12: Checkbox;
    checkboxWed13: Checkbox;
    checkboxWed14: Checkbox;
    checkboxWed15: Checkbox;
    checkboxWed16: Checkbox;
    checkboxWed17: Checkbox;
    checkboxWed18: Checkbox;
    checkboxWed19: Checkbox;
    checkboxWed1: Checkbox;
    checkboxWed20: Checkbox;
    checkboxWed21: Checkbox;
    checkboxWed22: Checkbox;
    checkboxWed23: Checkbox;
    checkboxWed2: Checkbox;
    checkboxWed3: Checkbox;
    checkboxWed4: Checkbox;
    checkboxWed5: Checkbox;
    checkboxWed6: Checkbox;
    checkboxWed7: Checkbox;
    checkboxWed8: Checkbox;
    checkboxWed9: Checkbox;
    checkboxWednesday: Checkbox;
    checkboxWeds0: Checkbox;
    label0600: Label;
    label1Thirteen: Label;
    labelEight: Label;
    labelEighteen: Label;
    labelEleven: Label;
    labelFifteen: Label;
    labelFive: Label;
    labelFour: Label;
    labelFourteen: Label;
    labelMidnight: Label;
    labelNine: Label;
    labelNineteen: Label;
    labelOne: Label;
    labelSeven: Label;
    labelSeventeen: Label;
    labelSixteen: Label;
    labelTen: Label;
    labelThree: Label;
    labelTitle: Label;
    labelTwelve: Label;
    labelTwenty: Label;
    labelTwentyOne: Label;
    labelTwentyThree: Label;
    labelTwentyTwo: Label;
    labelTwo: Label;
    panelSchedule: Panel;
    sourceEdischedule: DataSource;
    textboxFrequency: Textbox;
    textboxStart: Textbox;
}
